import api from "@/libs/axios";
import * as ep from "./endpoints";

export default {
  namespaced: true,
  state: () => ({
    slids: [],
    organizations: {
      data: [],
      pagination: {},
    },
    loading: false,
    loadingOrg: false,
    loadingPagination: false,
    aboutPlatform: {},
    loadingAbout: false,
    foundingOrganization: {},
    loadingFounding: false,
    filterQueue: 0,
    campaigns: [],
    campaignsPagination: {},
    loadingCampaigns: false,
  }),
  getters: {
    ngoSlider(state) {
      return state.slids;
    },
    ngoOrganizations(state) {
      return state.organizations;
    },
    ngoAboutPlatform(state) {
      return state.aboutPlatform;
    },
    ngoFoundingOrganization(state) {
      return state.foundingOrganization;
    },
    loading(state) {
      return state.loading;
    },
    loadingOrg(state) {
      return state.loadingOrg;
    },
    filterLoading(state) {
      return state.filterQueue;
    },
    loadingPagination(state) {
      return state.loadingPagination;
    },
    loadingAbout(state) {
      return state.loadingAbout;
    },
    campaigns(state) {
      return state.campaigns;
    },
    campaignsPagination(state) {
      return state.campaignsPagination;
    },
    loadingCampaigns(state) {
      return state.loadingCampaigns;
    },
  },
  mutations: {
    ngoSlider(state, payload) {
      state.slids = payload;
    },
    ngoOrganizations(state, payload) {
      state.organizations = payload;
    },
    ngoAboutPlatform(state, payload) {
      state.aboutPlatform = payload;
    },
    ngoFoundingOrganization(state, payload) {
      state.foundingOrganization = payload;
    },
    setLoadingOrg(state, val) {
      state.loadingOrg = val;
    },
    setLoading(state, val) {
      state.loading = val;
    },
    setLoadingPagination(state, val) {
      state.loadingPagination = val;
    },
    setLoadingFounding(state, val) {
      state.loadingFounding = val;
    },
    setLoadingAbout(state, val) {
      state.loadingAbout = val;
    },
    setFilterQueue(state, val) {
      if (val) state.filterQueue++;
      else state.filterQueue--;
    },
    setCampaigns(state, val) {
      state.campaigns = val;
    },
    setCampaignsPagination(state, val) {
      state.campaignsPagination = val;
    },
    setLoadingCampagins(state, val) {
      state.loadingCampaigns = val;
    },
  },
  actions: {
    async getSlids(context) {
      context.commit("setLoading", true);
      await api
        .get(ep.Slider_endpoint)
        .then((res) => {
          context.commit("ngoSlider", res.data.data);
          context.commit("setLoading", false);
        })
        .catch((err) => {});
    },

    async getOrganizations(context, payload) {
      context.commit("setLoadingOrg", true);
      await api
        .get(ep.organizations(payload.currentPage, payload.filter))
        .then((res) => {
          context.commit("ngoOrganizations", res.data);
          context.commit("setLoadingOrg", false);
        })
        .catch((err) => {});
    },

    async getOrganizationsFilter(context, payload) {
      context.commit("setFilterQueue", true);

      await api
        .get(ep.organizations(payload.currentPage, payload.filter))
        .then((res) => {
          context.commit("ngoOrganizations", res.data);
          context.commit("setFilterQueue", false);
        })
        .catch((err) => {});
    },

    async getOrganizationsPagination(context, payload) {
      context.commit("setLoadingPagination", true);
      await api
        .get(ep.organizations(payload.currentPage, payload.filter))
        .then((res) => {
          context.commit("ngoOrganizations", res.data);
          context.commit("setLoadingPagination", false);
        })
        .catch((err) => {});
    },

    async getAboutPlatform(context) {
      context.commit("setLoadingAbout", true);

      await api
        .get(ep.website_brief)
        .then((res) => {
          context.commit("ngoAboutPlatform", res.data.data);
          context.commit("setLoadingAbout", false);
        })
        .catch((err) => {});
    },

    async getShuffledCampaigns(context) {
      context.commit("setLoadingCampagins", true);

      await api
        .get(ep.SHUFFLED_CAMPAIGNS)
        .then((res) => {
          context.commit("setCampaigns", res.data.data);
          context.commit("setCampaignsPagination", res.data.pagination);
          context.commit("setLoadingCampagins", false);
        })
        .catch((err) => {});
    },

    async getFoundingOrganization(context) {
      context.commit("setLoadingFounding", true);
      await api
        .get(ep.founding_organization)
        .then((res) => {
          context.commit("ngoFoundingOrganization", res.data.data);
          context.commit("setLoadingFounding", false);
        })
        .catch((err) => {});
    },
  },
};
